import React from 'react';

import { LINKS } from './constants';

import AnalyticalStages from '@components/SVG/ProductIcons/AnalyticalStages';
import DepositionStages from '@components/SVG/ProductIcons/DepositionStages';
import HeaterModules from '@components/SVG/ProductIcons/HeaterModules';
import HeaterPowerSupplies from '@components/SVG/ProductIcons/HeaterPowerSupplies';
import LinearActuators from '@components/SVG/ProductIcons/LinearActuators';
import Motion from '@components/SVG/ProductIcons/Motion';
import MotionControllers from '@components/SVG/ProductIcons/MotionControllers';
import PortAligners from '@components/SVG/ProductIcons/PortAligners';
import PushPullDevices from '@components/SVG/ProductIcons/PushPullDevices';
import RadialTelescopicTransferArms from '@components/SVG/ProductIcons/RadialTelescopicTransferArms';
import RotaryFeedthroughs from '@components/SVG/ProductIcons/RotaryFeedthroughs';
import SampleParking from '@components/SVG/ProductIcons/SampleParking';
import SampleTransferArms from '@components/SVG/ProductIcons/SampleTransferArms';
import ViewPortShutters from '@components/SVG/ProductIcons/ViewPortShutters';
import WobbleSticks from '@components/SVG/ProductIcons/WobbleSticks';

export const SVGPicker = (uid: string) => {
	let SVG;

	switch (uid) {
		case 'rotary-feedthroughs':
			SVG = <RotaryFeedthroughs />;
			break;

		case 'linear-actuators':
			SVG = <LinearActuators />;
			break;

		case 'sample-transfer-arms':
			SVG = <SampleTransferArms />;
			break;

		case 'y-xy-xyz-and-xyzt-motion':
			SVG = <Motion />;
			break;

		case 'wobble-sticks':
			SVG = <WobbleSticks />;
			break;

		case 'view-port-shutters':
			SVG = <ViewPortShutters />;
			break;

		case 'push-pull-devices':
			SVG = <PushPullDevices />;
			break;

		case 'analytical-stages':
			SVG = <AnalyticalStages />;
			break;

		case 'deposition-stages':
			SVG = <DepositionStages />;
			break;

		case 'heater-modules':
			SVG = <HeaterModules />;
			break;

		case 'motion-controllers':
			SVG = <MotionControllers />;
			break;

		case 'heater-power-supplies':
			SVG = <HeaterPowerSupplies />;
			break;

		case 'radial-telescopic-transfer-arms':
			SVG = <RadialTelescopicTransferArms />;
			break;

		case 'port-aligners':
			SVG = <PortAligners />;
			break;

		case 'sample-parking':
			SVG = <SampleParking />;
			break;

		default:
			break;
	}

	return SVG;
};

export const getExtension = (url: string) =>
	url ? url.split('.').pop()?.toUpperCase() : null;

export const bytesToSize = (bytes: number) => {
	const sizes = ['bytes', 'kb', 'mb', 'gb', 'tb'];

	if (bytes === 0) return '0 Byte';

	const i = Math.floor(Math.log(bytes) / Math.log(1024));
	return `${Math.round(bytes / Math.pow(1024, i))}${sizes[i]}`;
};

export const constructGroupSlug = (node, category) => {
	const parentUid = node.data
		? node.data.categorisation?.document?.uid
		: node.categorisation?.document?.uid;

	const categoryUid = category.edges
		.filter(({ node }) => {
			return node.uid === parentUid ? node.uid : null;
		})
		.map(({ node }) => node.uid);

	return `${LINKS.PRODUCTS}${
		categoryUid ? `/${categoryUid.toString()}` : ''
	}/${node.uid}`;
};

export const constructProductSlug = (node, group = null) => {
	const parentType = node.data
		? node.data.categorisation?.document?.type
		: node.categorisation?.document?.type;
	const parentUid = node.data
		? node.data.categorisation?.document?.uid
		: node.categorisation?.document?.uid;

	if (group === null) return `${LINKS.PRODUCTS}/${parentUid}/${node.uid}`;

	const categoryUid =
		parentType === 'product_group'
			? group.edges
				? group.edges
						.filter(({ node }) => {
							return node.uid === parentUid
								? node.data.categorisation.document.uid
								: null;
						})
						.map(
							({ node }) => node.data.categorisation.document.uid
						)
				: group.uid === parentUid
				? group.data.categorisation.document.uid
				: null
			: null;

	return `/products${
		categoryUid ? `/${categoryUid.toString()}` : ''
	}/${parentUid}/${node.uid}`;
};

export const stringToHTML = (string) => {
	const isBrowser = typeof window !== 'undefined';

	if (!isBrowser) return;

	const parser = new DOMParser();
	const doc = parser.parseFromString(string, 'text/html');
	return doc.body.children;
};

export const hasContent = (HTML) => {
	if (!HTML) return false;

	if (HTML?.length > 1) return true;
	return HTML[0]?.children?.length > 0;
};

// Strip the ID from the src, and attach to the API call
export const getVimeoPoster = (src: string) => {
	const vimeoValue = src.replace(/\D/g, '');

	return `https://vumbnail.com/${vimeoValue}.jpg`;
};

// Filter all query string values into a 'params' object, then locate the ID and attach to the API call
export const getYouTubePoster = (src: string) => {
	const params = new Proxy(new URLSearchParams(src.split('?').pop()), {
		get: (searchParams, prop) => searchParams.get(prop),
	});
	const youtubeValue = params.v;

	return `https://i.ytimg.com/vi/${youtubeValue}/maxresdefault.jpg`;
};
